import type { Tutorial } from '../types'

const IMG = '/images/tutorials/web/health-records'

export const healthRecordsWebTutorial: Tutorial = {
  slug: 'health-records',
  platform: 'web',
  title: 'Health Records',
  subtitle: 'Structured records in the main dashboard',
  date: '2026-07-09',
  category: 'Core Features',
  tags: ['Health Records', 'conditions', 'supplements', 'labs'],
  description:
    'Conditions, supplements, treatments, allergies, and lab results — organized in category tabs with tailored add forms, all readable by Wellness Coach.',
  highlights: [
    'Category tabs across the top of the Health Records page.',
    'Each category has its own add form with the right fields.',
    'Records ground every Wellness Coach answer on web and mobile.',
  ],
  coverImage: `${IMG}/01-records-list.png`,
  sections: [
    {
      heading: 'Records by category',
      paragraphs: [
        '**Health Records** opens with category navigation — switch between Conditions, Supplements, Treatments, Allergies, and Lab Results without leaving the page.',
      ],
      image: {
        src: `${IMG}/01-records-list.png`,
        alt: 'Health Records list on Livewello web',
        caption: 'Health Records list',
      },
    },
    {
      heading: 'Supplements and status',
      paragraphs: [
        'Each category shows status at a glance — active, inactive, or resolved — with dosage and frequency where relevant.',
      ],
      image: {
        src: `${IMG}/02-supplements-category.png`,
        alt: 'Supplements category in Health Records on web',
        caption: 'Supplements category',
      },
    },
    {
      heading: 'Adding a record',
      paragraphs: [
        '**Add** opens a structured form for the active category — name, description, dates, and category-specific fields like dosage for supplements or values for lab results.',
      ],
      image: {
        src: `${IMG}/03-add-supplement-form.png`,
        alt: 'Add Supplement form on web',
        caption: 'Add Supplement form',
      },
    },
  ],
  whyMatters:
    'Trustworthy, form-based data entry is what makes coaching personal. A supplement logged here is what Wellness Coach checks before answering interaction questions — on web or mobile.',
  relatedSlugs: ['wellness-coach', 'profile-sharing'],
  meta: {
    description: 'Health Records on Livewello web: category tabs and structured add forms.',
    ogImage: `${IMG}/01-records-list.png`,
  },
}
